import {
    useEffect,
    useState
}
from "react";

import API from "../../services/api";

function LowStock() {

    const [products,
        setProducts] =
        useState([]);

    useEffect(() => {
        loadProducts();
    }, []);

    const loadProducts =
        async () => {

            try {

                const res =
                    await API.get(
                        "/stock-alerts"
                    );

                setProducts(
                    res.data
                );

            } catch (err) {

                console.log(err);

            }

        };

    return (
        <div>

            <div
                className="
                flex
                justify-between
                items-center
                mb-6
                "
            >

                <h1
                    className="
                    text-4xl
                    font-bold
                    "
                >
                    Low Stock Alerts
                </h1>

                <div
                    className="
                    bg-red-500
                    px-5
                    py-3
                    rounded-xl
                    font-semibold
                    "
                >
                    {products.length}
                    Alerts
                </div>

            </div>

            <div
                className="
                grid
                md:grid-cols-4
                gap-5
                mb-8
                "
            >

                <div
                    className="
                    bg-[#111]
                    rounded-2xl
                    p-6
                    "
                >
                    <p>
                        Total Alerts
                    </p>

                    <h2
                        className="
                        text-4xl
                        font-bold
                        text-red-400
                        "
                    >
                        {
                            products.length
                        }
                    </h2>
                </div>

            </div>

            <div
                className="
                bg-[#111]
                rounded-2xl
                overflow-hidden
                "
            >

                <div
                    className="
                    overflow-x-auto
                    "
                >

                    <table
                        className="
                        w-full
                        "
                    >

                        <thead>

                            <tr
                                className="
                                border-b
                                border-yellow-500/20
                                "
                            >

                                <th className="p-4 text-left">
                                    Product
                                </th>

                                <th className="p-4 text-left">
                                    Category
                                </th>

                                <th className="p-4 text-left">
                                    Stock
                                </th>

                                <th className="p-4 text-left">
                                    Status
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {products.map(
                                (item) => (

                                    <tr
                                        key={item.id}
                                        className="
                                        border-b
                                        border-yellow-500/10
                                        "
                                    >

                                        <td className="p-4">
                                            {item.name}
                                        </td>

                                        <td className="p-4">
                                            {
                                                item.category_name
                                            }
                                        </td>

                                        <td
                                            className="
                                            p-4
                                            text-red-400
                                            font-bold
                                            "
                                        >
                                            {
                                                item.stock
                                            }
                                        </td>

                                        <td className="p-4">

                                            <span
                                                className="
                                                bg-red-500
                                                px-3
                                                py-1
                                                rounded-full
                                                text-sm
                                                "
                                            >
                                                Low Stock
                                            </span>

                                        </td>

                                    </tr>

                                )
                            )}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>
    );
}

export default LowStock;